var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookOpenText = function SvgBookOpenText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.943h-8a5 5 0 0 0-4 2 5 5 0 0 0-4-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a3 3 0 0 1 3 3 1 1 0 0 0 2 0 3 3 0 0 1 3-3h8a2 2 0 0 0 2-2v-16a2 2 0 0 0-2-2Zm-16 18H4v-16h8a3 3 0 0 1 3 3v14a4.976 4.976 0 0 0-3-1Zm16 0h-8a4.976 4.976 0 0 0-3 1v-14a3 3 0 0 1 3-3h8v16Zm-8-13h5a1 1 0 1 1 0 2h-5a1 1 0 0 1 0-2Zm6 5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1Zm0 4a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1Z",
    fill: "#F2EEE4"
  })));
};
export default SvgBookOpenText;